export default __webpack_public_path__ + "static/weeping-24bb35564cc91b081ec20bc2311e613d.svg";